// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cookie-notice[data-v-17cc0ae9]{max-width:400px;width:400px}.cookie-notice .btn-link[data-v-17cc0ae9]{font-size:.875rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
